

































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import BpcInput from '@shared/components/forms/inputs/input/input.vue';

@Component({
  name: 'bpc-pos-specify-badge-modal',
  components: {
    BpcInput,
  },
})
export default class PosSpecifyBadgeModal extends Vue {
  // PROPS
  @Prop({ type: Boolean, default: false }) readonly loading: boolean;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Boolean, default: false }) readonly closeDisabled: boolean;
  @Prop({ type: Boolean, default: false }) readonly confirmDisabled: boolean;

  // DATA
  badgeNumber = '';
  confirmNoBadge = false;
  showConfirmNoBadgeModal = false;

  // COMPUTED
  // LIFECYCLE
  // METHODS

  closeModal() {
    this.$emit('close');
    this.badgeNumber = '';
  }

  onConfirmNoBadge() {
    this.confirmNoBadge = true;
    this.showConfirmNoBadgeModal = false;
    this.onConfirm();
  }

  async onConfirm() {
    if (!this.badgeNumber && !this.confirmNoBadge) {
      this.showConfirmNoBadgeModal = true;
      return;
    }
    const badgeNumber = this.badgeNumber;
    this.$emit('onConfirmAddBadge', badgeNumber);
    this.badgeNumber = '';
    this.showConfirmNoBadgeModal = false;
    this.confirmNoBadge = false;
  }

  // WATCHERS
}
